// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3ouAd","productName":"Table_productName__3b4rg"};